import { render, staticRenderFns } from "./PolticallyExposedPerson.vue?vue&type=template&id=e984217e&scoped=true"
import script from "./PolticallyExposedPerson.vue?vue&type=script&lang=js"
export * from "./PolticallyExposedPerson.vue?vue&type=script&lang=js"
import style0 from "./PolticallyExposedPerson.vue?vue&type=style&index=0&id=e984217e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e984217e",
  null
  
)

export default component.exports